import { useState, useEffect, useContext, useRef } from 'react'
import Layout from "../../../components/layout"
import { HeaderWrapper, ContentWrapper, ProtienInformation, ProductInformation, DyeInformation, PriceInformation, ProductFormulation, ImageInformation } from './style'
import Input from '../../../components/Input'
import { addProductApi, updateProductApi, uploadFileApi, getProductCategoriesApi, addProductCategoryApi, getProductsApi, generatePDFApi } from '../../../api'
import { AuthContext } from '../../../context/auth'
import Dropdown from "../../../components/Dropdown"
import { proteinsList } from '../../../utils/proteinName'
import { toAbsoluteUrl } from '../../../utils/assetHelper'
import { prefillData } from '../../../utils/prefillData'
import { isVideoFile, getMp4Url, isMp4 } from '../../../utils/videoHelper'
import { Prices } from '../../../utils/prices'
import { Checkbox } from '../../../components/Checkbox'
import slugify from 'react-slugify';
import axios from 'axios';
import TextEditor from '../../../components/Editor'

const ImagesKey = [
  "Western Blotting",
  "Multiplexed Protein Expression and Host Cell Protein",
  "Widefield",
  "Widefield SIM",
  "Confocal",
  "Super Resolution - Airyscan",
  "Super Resolution - SIM",
  "Super Resolution - SIM²",,
  "Flow Cytometry",
  "Super Resolution - Single Molecule STORM",
  "Control",
];

const proteinApplicationsList = [
    {
    name: 'Flow Cytometry',
    abbr: 'FC'
  },
  {
    name: 'Multiplexed Immunoassay',
    abbr: 'MI'
  },
    {
    name: 'Western Blotting',
    abbr: 'WB'
  },
    {
    name: 'Multiplexed Protein Expression Testing',
    abbr: 'HCP'
  }
]

const microscopyApplicationList = [
    {
        name: 'Widefield',
        abbr: 'WF'
    },
    {
        name: 'Widefield SIM',
        abbr: 'WF-SIM'
    },
    {
        name: 'Confocal',
        abbr: 'CLSM'
    },
    {
        name: 'Super Resolution Airyscan',
        abbr: 'SRM-AS'
    },
    {
        name: 'Super Resolution SIM',
        abbr: 'SRM-SIM'
    },
    {
        name: 'Super Resolution SIM²',
        abbr: 'SRM-SIM²'
    },
    {
        name: 'Control',
        abbr: 'Control'
    },
    {
        name: 'Super Resolution / Single Molecule - STORM',
        abbr: 'STORM'
    }
]

const Index = ({ setOpenAddProduct, type, productCategory, selectedProduct, setSelectedProduct }) => {
  const [videoConversionStatus, setVideoConversionStatus] = useState({})
  const { setNotification, setIsLoading, isLoading } = useContext(AuthContext)
  const [productCategories, setProductCategories] = useState([])
  const [selectedProductCategory, setSelectedProductCategory] = useState()
  const [productType, setProductType] = useState(type)
  const [subProductType, setSubProductType] = useState('')
  const [prefix, setPrefix] = useState('')
  const [batchNumber, setBatchNumber] = useState(['', '', '', '', '', ''])
  const [proteinName, setProteinName] = useState('')
  const [proteinDescription, setProteinDescription] = useState('')
  const [reference, setReference] = useState(['', '', '', '', '', '', '', ''])
  const [productName, setProductName] = useState('')
  const [tempProductName, setTempProductName] = useState('')
  const [immunogen, setImmunogen] = useState('')
  const [uniprotId, setUniprotId] = useState('')
  const [geneId, setGeneId] = useState('')
  const [geneSymbol, setGeneSymbol] = useState('')
  const [geneAliases, setGeneAliases] = useState('')
  const [cloneId, setCloneId] = useState('')
  const [modifications, setModifications] = useState('')
  const [host, setHost] = useState()
  const [clonality, setClonality] = useState('')
  const [subclass, setSubclass] = useState('')
  const [variant, setVariant] = useState('')
  const [speciesReactivity, setSpeciesReactivity] = useState('')
  const [chainSpecificity, setChainSpecificity] = useState('')
  const [bindingSpecificity, setBindingSpecificity] = useState([])
  const [dye, setDye] = useState('')
  const [excitationWavelength, setExcitationWavelength] = useState('')
  const [emissionWavelength, setEmissionWavelength] = useState('')
  const [extinctionCoefficient, setExtinctionCoefficient] = useState('')
  const [molecularWeight, setMolecularWeight] = useState('')
  const [emissionColor, setEmissionColor] = useState('')
  const [buffer, setBuffer] = useState('Phosphate Buffer')
  const [bufferMolarity, setBufferMolarity] = useState('10')
  const [ph, setPh] = useState('7.4')
  const [preservative, setPreservative] = useState('Azide')
  const [cyroPreservative, setCyroPreservative] = useState('Glycerol')
  const [storage, setStorage] = useState(['4'])
  const [concentration, setConcentration] = useState('')
  const [dillusionalMicroscopy, setDillusionalMicroscopy] = useState('')
  const [westernBloating, setWesternBloating] = useState('')
  const [proteinApplication, setProteinApplication] = useState([])
  const [microscopyApplication, setMicroscopyApplication] = useState([])
  const [productNumber, setProductNumber] = useState('')
  const [images, setImages] = useState([
    {
      name: 'Western Blotting',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Multiplexed Protein Expression and Host Cell Protein',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Widefield',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Widefield SIM',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Confocal',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Super Resolution - Airyscan',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Super Resolution - SIM',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Super Resolution - SIM²',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Flow Cytometry',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Super Resolution - Single Molecule STORM',
      url: '',
      methods: '',
      featuredImage: false
    },
    {
      name: 'Control',
      url: '',
      methods: '',
      featuredImage: false
    }
  ])
  const [sds, setSds] = useState()
  const [coa, setCoa] = useState()
  const [thermofisherLink, setThermofisherLink] = useState('')
  const [price, setPrice] = useState()
  const [quantity, setQuantity] = useState(10)
  const [isFeatured, setIsFeatured] = useState(false)
  const [editorFocussed, setEditorFocussed] = useState({
    name: '',
    status: false
  });

  useEffect(() => {
    if (productType === 'PA - Primary Antibody') {
      if (subProductType === 'PA-MM - Mouse Monoclonal') {
        setPrefix('PA-MM')
        setHost('Mouse')
        setClonality('Monoclonal')
      } else if (subProductType === 'PA-MR - Mouse Recombinant Monoclonal') {
        setPrefix('PA-MR')
        setHost('Mouse')
        setClonality('Recombinant Monoclonal')
      } else if (subProductType === 'PA-RR - Rabbit Recombinant Monoclonal') {
        setPrefix('PA-RR')
        setHost('Rabbit')
        setClonality('Recombinant Monoclonal')
      }
      else if (subProductType === 'PA-RP - Rabbit Polyclonal') {
        setPrefix('PA-RP')
        setHost('Rabbit')
        setClonality('Polyclonal')
      }
      else if (subProductType === 'PA-RTM - Rat Monoclonal') {
        setPrefix('PA-RTM')
        setHost('Rat')
        setClonality('Monoclonal')
      }
    } else if (productType === 'DC - Primary Antibody Direct Conjugate') {
      setPrefix('DC')
      setSubProductType('')
    } else if (productType === 'SA - Secondary Antibody') {
      setPrefix('SA')
      setSubProductType('')
    } else if (productType === 'BU') {
      setPrefix('BU')
      setSubProductType('')
    } else if (productType === 'GL') {
      setPrefix('GL')
      setSubProductType('')
    } else if (productType === 'MM') {
      setPrefix('MM')
      setSubProductType('')
    }

  }, [productType, subProductType])

  useEffect(() => {
    if (productType === 'PA - Primary Antibody') {
      if (host === 'Mouse' && clonality === 'Monoclonal') {
        setSubProductType('PA-MM - Mouse Monoclonal')
      }
      if (host === 'Mouse' && clonality === 'Recombinant Monoclonal') {
        setSubProductType('PA-MR - Mouse Recombinant Monoclonal')
      }
      if (host === 'Rabbit' && clonality === 'Recombinant Monoclonal') {
        setSubProductType('PA-RR - Rabbit Recombinant Monoclonal')
      }
      if (host === 'Rabbit' && clonality === 'Polyclonal') {
        setSubProductType('PA-RP - Rabbit Polyclonal')
      }
      if (host === 'Rat' && clonality === 'Monoclonal') {
        setSubProductType('PA-RTM - Rat Monoclonal')
      }
    }
  }, [host, clonality, productType])


  useEffect(() => {
    if (selectedProductCategory) {
      if (prefix !== selectedProduct?.mid_code) {
        getProductsApi(selectedProductCategory, "10", "0", "", { name: '-material' }).then((res) => {
          if (res && res.data) {
            if (res.data?.products?.length) {
              const lastValue = res.data?.products?.sort((a, b) => Number(b.material) - Number(a.material))[0].material;
              if (lastValue) {
                const nextValue = Number(lastValue) + 1;
                setProductNumber(nextValue.toString().padStart(6, '0'));
              } else {
                setProductNumber("1".toString().padStart(6, '0'))
              }
            } else {
              setProductNumber("1".toString().padStart(6, '0'))
            }
          }
        })
      } else {
        setProductNumber(selectedProduct?.material)
      }
    } else {
      setProductNumber(selectedProduct?.material)
    }

  }, [selectedProductCategory, prefix])


  useEffect(() => {
    if (productType === 'PA - Primary Antibody') {
      setTempProductName(`${host ? host : ''} <span style="font-weight: 600">anti-Human</span> ${proteinName ? proteinName : ''}${modifications ? ` (${modifications})` : ''} ${clonality ? clonality : ''}${variant ? `, ${variant}` : ''}${subclass ? `, ${subclass}` : ''}`)
      setProductName(`${host} anti-Human ${proteinName}${modifications ? ` (${modifications})` : ''} ${clonality}${variant ? `, ${variant}` : ''}`)
    }
    else if (productType === 'DC - Primary Antibody Direct Conjugate') {
      setTempProductName(`${host ? host : ''} <span style="font-weight: 600">anti-Human</span> ${proteinName ? proteinName : ''}${modifications ? ` (${modifications})` : ''} ${clonality ? clonality : ''} <span style="font-weight: 600">- Identifyn® SRM Alexa Fluor™</span> ${dye ? dye : ''}${variant ? `, ${variant}` : ''}${subclass ? `, ${subclass}` : ''}`)
      setProductName(`${host} anti-Human ${proteinName}${modifications ? ` (${modifications})` : ''} ${clonality} - Identifyn® SRM Alexa Fluor™ ${dye}${variant ? `, ${variant}` : ''}`)
    } else {
      setTempProductName(`<span style="font-weight: 600">Identifyn® SRM Alexa Fluor™</span> ${dye ? dye : ''} <span style="font-weight: 600">Affinity Purified</span> ${host ? host : ''} ${speciesReactivity ? speciesReactivity : ''} ${chainSpecificity ? chainSpecificity : ''} ${bindingSpecificity && bindingSpecificity.length ? bindingSpecificity.map(spec => spec.replace("(Subclasses 1+2a+2b+3)", "(Subclasses 1+2a+2b+3), Fcy Fragment Specific")).join(", ") : ''}`)
      setProductName(`Identifyn® SRM Alexa Fluor™ ${dye} Affinity Purified ${host} ${speciesReactivity}, ${chainSpecificity} ${bindingSpecificity && bindingSpecificity.length ? bindingSpecificity.map(spec => spec.replace("(Subclasses 1+2a+2b+3)", "(Subclasses 1+2a+2b+3), Fcy Fragment Specific")).join(", ") : ''}`)
    }
  }, [productType, proteinName, host, clonality, dye, speciesReactivity, chainSpecificity, bindingSpecificity, variant, subclass, modifications])

  function cleanFileName(fileName) {
    let x = fileName.replace(/[^a-zA-Z0-9-_\. ]/g, "");
    x = x.replace(/ +/g, " ");
    return x.replace(/ /g, "_");
  }

  const convertFile = async (file, name) => {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `https://fyrn22sobcvw5amur43hkxof7u0iwtdm.lambda-url.us-east-1.on.aws/?videoKey=${file}`,
      headers: {
        'Content-Type': 'application/json'
      },
    };
    setVideoConversionStatus(prevStatus => ({
      ...prevStatus,
      [name]: { status: true, url: file }
    }));
    try {
      const response = await axios.request(config);
      setVideoConversionStatus(prevStatus => ({
        ...prevStatus,
        [name]: { status: false, url: getMp4Url(file) }
      }))
    } catch (error) {
      console.log(error);
      setVideoConversionStatus(prevStatus => ({
        ...prevStatus,
        [name]: { status: false, url: file }
      }))
    }

  }

  const uploadImage = (e, name) => {
    const file = e.target.files[0]
    if (file) {
      const MAX_IMAGE_SIZE = 15 * 1024 * 1024;
      const MAX_VIDEO_SIZE = 400 * 1024 * 1024;

      if ((file.type.startsWith('image/') && file.size > MAX_IMAGE_SIZE) ||
        (file.type.startsWith('video/') && file.size > MAX_VIDEO_SIZE)) {
        setNotification({
          message: `File size exceeds the ${file.type.startsWith('image/') ? '15 MB' : '100 MB'} limit for ${file.type.startsWith('image/') ? 'images' : 'videos'}.`,
          type: "red"
        });
        return;
      } else {
        setIsLoading(true)
        const formData = new FormData();
        formData.append('files', file, cleanFileName(file.name));
        uploadFileApi(formData).then((res) => {
          if (res && res.data) {
            if (isVideoFile(res.data?.uploads[0])) {
              !isMp4(res.data?.uploads[0]) && convertFile(res.data?.uploads[0]?.key, name)
              setImages(images.map((item) => {
                if (item.name === name) {
                  return {
                    ...item,
                    url: res.data?.uploads[0]?.url
                  }
                }
                return item
              }))
              setIsLoading(false)
            } else {
              setImages(images.map((item) => {
                if (item.name === name) {
                  return {
                    ...item,
                    url: res.data?.uploads[0]?.url
                  }
                }
                return item
              }))
              setIsLoading(false)
              setNotification({
                message: "Image Uploaded Successfully",
                type: "green"
              })
            }
          }
        }).catch((err) => {
          setNotification({
            message: "Something went wrong",
            type: "red"
          })
          setIsLoading(false)
        })
      }
    }
  }

  const uploadSds = (e) => {
    const file = e.target.files[0]
    if (file) {{
        setIsLoading(true)
        const formData = new FormData();
        formData.append('files', file, cleanFileName(file.name));
        uploadFileApi(formData).then((res) => {
          if (res && res.data) {
            setSds({
              url: res.data?.uploads[0]?.url,
              name: res.data?.uploads[0]?.key
            })
            setIsLoading(false)
          }
        }).catch((err) => {
          setNotification({
            message: "Something went wrong",
            type: "red"
          })
          setIsLoading(false)
        })

    }
  }
}

const generatePDF = (type, id) => {
  setIsLoading(true)
  generatePDFApi(type, id).then(res => {
    if (res && res.data) {
      setSelectedProduct({
        ...selectedProduct,
        metadata: res.data
      })
      if (type === "all") {
        setNotification({
          message: `Sent, Confirm in SharePoint`,
          type: "red"
        })
      }
      else {
        setNotification({
          message: `${type === sds ? 'SDS' : 'PDF'} Generated Successfully`,
          type: "red"
        })
      }
      setIsLoading(false)
    }
  }).catch(err => {
    setNotification({
      message: err?.error || err?.message || "Something went wrong",
      type: "red"
    })
    setIsLoading(false)
  })
}


  const fetchProductCategories = () => {
    setIsLoading(true)
    getProductCategoriesApi()
      .then(res => {
        if (res && res.data?.product_categories && res.data?.product_categories.length > 0) {
          setProductCategories(res.data?.product_categories)
          setIsLoading(false)
        } else {
          setProductCategories([])
          setIsLoading(false)
        }
      }).catch(err => {
        console.error(err)
        setIsLoading(false)
      })
  }


  useEffect(() => {
    fetchProductCategories()
  }, [])


  useEffect(() => {
    if (productType === 'PA - Primary Antibody') {
      const categoryId = productCategories?.find((item) => item?.name == 'Primary Antibodies')
      if (categoryId) {
        let subCategoryId = ''
        if (subProductType === 'PA-MM - Mouse Monoclonal') {
          subCategoryId = categoryId?.category_children?.find((item) => item?.name == 'PA-MM Mouse Monoclonal')?.id
          if (subCategoryId) {
            setSelectedProductCategory(subCategoryId)
          } else {
            setSelectedProductCategory()
          }
        } else if (subProductType === 'PA-MR - Mouse Recombinant Monoclonal') {
          subCategoryId = categoryId?.category_children?.find((item) => item?.name == 'PA-MR Mouse Recombinant Monoclonal')?.id
          if (subCategoryId) {
            setSelectedProductCategory(subCategoryId)
          }
          else {
            setSelectedProductCategory()
          }
        } else if (subProductType === 'PA-RR - Rabbit Recombinant Monoclonal') {
          subCategoryId = categoryId?.category_children?.find((item) => item?.name == 'PA-RR Rabbit Recombinant Monoclonal')?.id
          if (subCategoryId) {
            setSelectedProductCategory(subCategoryId)
          }
          else {
            setSelectedProductCategory()
          }
        } else if (subProductType === 'PA-RP - Rabbit Polyclonal') {
          subCategoryId = categoryId?.category_children?.find((item) => item?.name == 'PA-RP Rabbit Polyclonal')?.id
          if (subCategoryId) {
            setSelectedProductCategory(subCategoryId)
          }
          else {
            setSelectedProductCategory()
          }
        } else if (subProductType === 'PA-RTM - Rat Monoclonal') {
          subCategoryId = categoryId?.category_children?.find((item) => item?.name == 'PA-RTM Rat Monoclonal')?.id
          if (subCategoryId) {
            setSelectedProductCategory(subCategoryId)
          }
          else {
            setSelectedProductCategory()
          }
        }
      } else {
        setSelectedProductCategory()
      }
    } else if (productType === 'DC - Primary Antibody Direct Conjugate') {
      const categoryId = productCategories?.find((item) => item?.name == 'Alexa Flour Primary Antibodies')
      if (categoryId) {
        setSelectedProductCategory(categoryId?.id)
      }
      else {
        setSelectedProductCategory()
      }
    } else if (productType === 'SA - Secondary Antibody') {
      const categoryId = productCategories?.find((item) => item?.name == 'Alexa Flour Secondary Antibodies')
      if (categoryId) {
        setSelectedProductCategory(categoryId?.id)
      }
      else {
        setSelectedProductCategory()
      }
    } else if (productType === 'GL') {
      const categoryId = productCategories?.find((item) => item?.name == 'Glass')
      if (categoryId) {
        setSelectedProductCategory(categoryId?.id)
      }
      else {
        setSelectedProductCategory()
      }
    } else if (productType === 'BU') {
      const categoryId = productCategories?.find((item) => item?.name == 'Buffers')
      if (categoryId) {
        setSelectedProductCategory(categoryId?.id)
      }
      else {
        setSelectedProductCategory()
      }
    } else if (productType === 'MM') {
      const categoryId = productCategories?.find((item) => item?.name == 'Mounting Medium')
      if (categoryId) {
        setSelectedProductCategory(categoryId?.id)
      }
      else {
        setSelectedProductCategory()
      }
    }
  }, [productType, subProductType, productCategories])

const payloadData = {
      title: productName,
      subtitle: proteinName,
      description: '',
      immunogen: immunogen,
      host: host,
      clonality: clonality,
      species_reactivity: speciesReactivity,
      dyes: dye,
      chain_specification: chainSpecificity,
      binding_specification: bindingSpecificity,
      excitation_wavelength: excitationWavelength,
      emission_wavelength: emissionWavelength,
      extinction_coefficient: extinctionCoefficient,
      molecular_weight: molecularWeight,
      emission_color: emissionColor,
      buffer: buffer,
      buffer_molarity: bufferMolarity,
      ph: ph,
      preservative: preservative,
      cyropreservative: cyroPreservative,
      storage: storage,
      concentration: concentration,
      dillusion_microscopy: dillusionalMicroscopy,
      western_bloating: westernBloating,
      protein_application: [],
      microscopy_aplication: [],
      mid_code: prefix,
      material: productNumber,
      featured: isFeatured,
      status: 'published',
      handle: `${slugify(`${productName}-${prefix}-${productNumber}`)}`,
      tags: [
        //   {
        //   value:`${host} ${clonality}`,
        // },
        // {
        //   value:`${dye}`
        // },
        {
          value: `${proteinName}`
        }
      ],
      metadata: {
        images: images,
        reference: reference,
        batch_number: batchNumber,
        subclass: subclass,
        microscopy_application: microscopyApplication,
        protein_application: proteinApplication,
        description: proteinDescription,
        variant: variant,
        uniprotId: uniprotId,
        geneId: geneId,
        geneAliases: geneAliases,
        geneSymbol: geneSymbol,
        cloneId: cloneId,
        sds: sds,
        thermofisher_link: thermofisherLink,
        modifications: modifications
      },
      variants: [
        {
          manage_inventory: false,
          inventory_quantity: quantity,
          title: productName,
          prices: [
            {
              amount: price * 100,
              currency_code: 'USD',
              // region_id: reg_01HGJBJTP7EEDV5899E4TDRR00
            }
          ]
        }
      ],
}


  const addProduct = (data) => {
    setIsLoading(true)
    if (selectedProductCategory) {
      addProductApi({
        ...data, categories: [
          {
            id: selectedProductCategory
          }
        ]
      }).then(res => {
        if (res) {
          setNotification({
            type: 'green',
            message: 'Product Added successfully'
          })
          setOpenAddProduct(false)
          setIsLoading(false)
          setSelectedProduct(null)
        }
        else {
          setNotification({
            type: 'red',
            message: 'Something went wrong'
          })
          setIsLoading(false)
        }
      }).catch(err => {
        setNotification({
          type: 'red',
          message: 'Something went wrong'
        })
        setIsLoading(false)
      })
    } else {
      // if categoryId is not there then create category and add product
      if (productType === 'PA - Primary Antibody') {
        const parentCategoryId = productCategories.find((item) => item.name === 'Primary Antibodies')
        if (parentCategoryId) {
          if (subProductType === "PA-MM - Mouse Monoclonal") {
            addProductCategoryApi({
              name: 'PA-MM Mouse Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              addProductApi({
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                } else {
                  setNotification({
                    type: 'red',
                    message: 'Something went wrong'
                  })
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-MR - Mouse Recombinant Monoclonal") {
            addProductCategoryApi({
              name: 'PA-MR Mouse Recombinant Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              addProductApi({
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                } else {
                  setNotification({
                    type: 'red',
                    message: 'Something went wrong'
                  })
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RR - Rabbit Recombinant Monoclonal") {
            addProductCategoryApi({
              name: 'PA-RR Rabbit Recombinant Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              addProductApi({
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                } else {
                  setNotification({
                    type: 'red',
                    message: 'Something went wrong'
                  })
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RP - Rabbit Polyclonal") {
            addProductCategoryApi({
              name: 'PA-RP Rabbit Polyclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              addProductApi({
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                } else {
                  setNotification({
                    type: 'red',
                    message: 'Something went wrong'
                  })
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RTM - Rat Monoclonal") {
            addProductCategoryApi({
              name: 'PA-RTM Rat Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              addProductApi({
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                } else {
                  setNotification({
                    type: 'red',
                    message: 'Something went wrong'
                  })
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          }
        } else {
          addProductCategoryApi({
            name: 'Primary Antibodies',
          }).then(res => {
            if (res) {
              const parentId = res?.data?.product_category?.id
              if (subProductType == 'PA-MM - Mouse Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-MM Mouse Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  addProductApi({
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-MR - Mouse Recombinant Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-MR Mouse Recombinant Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  addProductApi({
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RR - Rabbit Recombinant Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-RR Rabbit Recombinant Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  addProductApi({
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RP - Rabbit Polyclonal') {
                addProductCategoryApi({
                  name: 'PA-RP Rabbit Polyclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  addProductApi({
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RTM - Rat Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-RTM Rat Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  addProductApi({
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              }
            }
          })
        }
      } else if (productType === 'DC - Primary Antibody Direct Conjugate') {
        addProductCategoryApi({
          name: 'Alexa Flour Primary Antibodies',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            addProductApi({
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              } else {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
              setIsLoading(false)
            })
          }
        })

      } else if (productType === 'SA - Secondary Antibody') {
        addProductCategoryApi({
          name: 'Alexa Flour Secondary Antibodies',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            addProductApi({
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              } else {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
              setIsLoading(false)
            })
          }
        })

      } else if (productType === 'BU') {
        addProductCategoryApi({
          name: 'Buffers',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            addProductApi({
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'GL') {
        addProductCategoryApi({
          name: 'Glass',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            addProductApi({
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'MM') {
        addProductCategoryApi({
          name: 'Mounting Medium',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            addProductApi({
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      }

    }
  }

  const editProduct = (data, isAuto) => {
    setIsLoading(true)
    if (selectedProductCategory) {
      updateProductApi(selectedProduct?.id, {
        ...data, categories: [
          {
            id: selectedProductCategory
          }
        ]
      }).then(res => {
        if (res?.data) {
          setNotification({
            type: 'green',
            message: isAuto ? 'Product Auto Saved successfully' : 'Product Edited successfully'
          })
          if(!isAuto){
            setOpenAddProduct(false)
            setSelectedProduct(null)
          }
          setIsLoading(false)
        } else {
          setNotification({
            type: 'red',
            message: 'Something went wrong'
          })
          setIsLoading(false)
        }
      }).catch(err => {
        setNotification({
          type: 'red',
          message: 'Something went wrong'
        })
        setIsLoading(false)
      })
    } else {
      // if categoryId is not there then create category and add product
      if (productType === 'PA - Primary Antibody') {
        const parentCategoryId = productCategories.find((item) => item.name === 'Primary Antibodies')
        if (parentCategoryId) {
          if (subProductType === "PA-MM - Mouse Monoclonal") {
            addProductCategoryApi({
              name: 'PA-MM Mouse Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              updateProductApi(selectedProduct?.id, {
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-MR - Mouse Recombinant Monoclonal") {
            addProductCategoryApi({
              name: 'PA-MR Mouse Recombinant Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              updateProductApi(selectedProduct?.id, {
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RR - Rabbit Recombinant Monoclonal") {
            addProductCategoryApi({
              name: 'PA-RR Rabbit Recombinant Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              updateProductApi(selectedProduct?.id, {
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RP - Rabbit Polyclonal") {
            addProductCategoryApi({
              name: 'PA-RP Rabbit Polyclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              updateProductApi(selectedProduct?.id, {
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          } else if (subProductType === "PA-RTM - Rat Monoclonal") {
            addProductCategoryApi({
              name: 'PA-RTM Rat Monoclonal',
              parent_category_id: parentCategoryId?.id
            }).then((res) => {
              updateProductApi(selectedProduct?.id, {
                ...data, categories: [
                  {
                    id: res?.data?.product_category?.id
                  }
                ]
              }).then(res => {
                if (res) {
                  setNotification({
                    type: 'green',
                    message: 'Product Added successfully'
                  })
                  setOpenAddProduct(false)
                  setIsLoading(false)
                }
              }).catch(err => {
                setNotification({
                  type: 'red',
                  message: 'Something went wrong'
                })
                setIsLoading(false)
              })
            })
          }
        } else {
          addProductCategoryApi({
            name: 'Primary Antibodies',
          }).then(res => {
            if (res) {
              const parentId = res?.data?.product_category?.id
              if (subProductType == 'PA-MM - Mouse Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-MM Mouse Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  updateProductApi(selectedProduct?.id, {
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-MR - Mouse Recombinant Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-MR Mouse Recombinant Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  updateProductApi(selectedProduct?.id, {
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RR - Rabbit Recombinant Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-RR Rabbit Recombinant Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  updateProductApi(selectedProduct?.id, {
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RP - Rabbit Polyclonal') {
                addProductCategoryApi({
                  name: 'PA-RP Rabbit Polyclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  updateProductApi(selectedProduct?.id, {
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              } else if (subProductType == 'PA-RTM - Rat Monoclonal') {
                addProductCategoryApi({
                  name: 'PA-RTM Rat Monoclonal',
                  parent_category_id: parentId
                }).then((res) => {
                  updateProductApi(selectedProduct?.id, {
                    ...data, categories: [
                      {
                        id: res?.data?.product_category?.id
                      }
                    ]
                  }).then(res => {
                    if (res) {
                      setNotification({
                        type: 'green',
                        message: 'Product Added successfully'
                      })
                      setOpenAddProduct(false)
                      setIsLoading(false)
                    }
                  }).catch(err => {
                    setNotification({
                      type: 'red',
                      message: 'Something went wrong'
                    })
                    setIsLoading(false)
                  })
                })
              }
            }
          })
        }
      } else if (productType === 'DC - Primary Antibody Direct Conjugate') {
        addProductCategoryApi({
          name: 'Alexa Flour Primary Antibodies',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            updateProductApi(selectedProduct?.id, {
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'SA - Secondary Antibody') {
        addProductCategoryApi({
          name: 'Alexa Flour Secondary Antibodies',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            updateProductApi(selectedProduct?.id, {
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'BU') {
        addProductCategoryApi({
          name: 'Buffers',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            updateProductApi(selectedProduct?.id, {
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'GL') {
        addProductCategoryApi({
          name: 'Glass',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            updateProductApi(selectedProduct?.id, {
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      } else if (productType === 'MM') {
        addProductCategoryApi({
          name: 'Mounting Medium',
        }).then(res => {
          if (res && res.data?.product_category?.id) {
            updateProductApi(selectedProduct?.id, {
              ...data, categories: [
                {
                  id: res?.data?.product_category?.id
                }
              ]
            }).then(res => {
              if (res) {
                setNotification({
                  type: 'green',
                  message: 'Product Added successfully'
                })
                setOpenAddProduct(false)
                setIsLoading(false)
              }
            }).catch(err => {
              setNotification({
                type: 'red',
                message: 'Something went wrong'
              })
            })
          }
        })

      }

    }
  }


  const isDisabled = () => {
    if (productType === 'PA - Primary Antibody') {
      if (!subProductType || !proteinName || !proteinDescription || !immunogen || !buffer || !bufferMolarity || !ph || !preservative || !cyroPreservative || !storage.length || !concentration || !dillusionalMicroscopy || !westernBloating || !proteinApplication.length || !microscopyApplication.length || !productName || !subclass || !host || !clonality || !price || !quantity) {
        return true
      } else {
        return false
      }
    } if (productType === 'SA - Secondary Antibody') {
      if (!buffer || !bufferMolarity || !ph || !preservative || !cyroPreservative || !storage.length || !concentration || !dillusionalMicroscopy || !westernBloating || !price || !quantity || !proteinApplication.length || !microscopyApplication.length || !productName || !host || !dye || !chainSpecificity || !bindingSpecificity.length || !speciesReactivity || !emissionColor || !emissionWavelength || !excitationWavelength || !extinctionCoefficient || !molecularWeight) {
        return true
      } else {
        return false
      }
    }
    else {
      if (!proteinName || !proteinDescription || !immunogen || !buffer || !bufferMolarity || !ph || !preservative || !cyroPreservative || !storage.length || !concentration || !dillusionalMicroscopy || !westernBloating || !price || !quantity || !proteinApplication.length || !microscopyApplication.length || !productName || !subclass || !host || !clonality || !dye || !emissionColor || !emissionWavelength || !excitationWavelength || !extinctionCoefficient || !molecularWeight) {
        return true
      } else {
        return false
      }
    }
  }


  useEffect(() => {
    if (selectedProduct) {
      setProteinName(selectedProduct?.subtitle ? selectedProduct?.subtitle : '')
      setBuffer(selectedProduct?.buffer)
      setBufferMolarity(selectedProduct?.buffer_molarity)
      setPh(selectedProduct?.ph)
      setPreservative(selectedProduct?.preservative)
      setCyroPreservative(selectedProduct?.cyropreservative)
      setStorage(selectedProduct?.storage ? selectedProduct?.storage : [])
      setConcentration(selectedProduct?.concentration)
      setDillusionalMicroscopy(selectedProduct?.dilution)
      setWesternBloating(selectedProduct?.western_bloating)
      setPrice(selectedProduct?.variants[0]?.prices[0]?.amount / 100)
      setQuantity(selectedProduct?.variants[0]?.inventory_quantity)
      setReference(selectedProduct?.metadata?.reference ? selectedProduct?.metadata?.reference : [])
      setBatchNumber(selectedProduct?.metadata?.batch_number ? selectedProduct?.metadata?.batch_number : [])
      setSubclass(selectedProduct?.metadata?.subclass ? selectedProduct?.metadata?.subclass : '')
      setVariant(selectedProduct?.metadata?.variant ? selectedProduct?.metadata?.variant : '')
      setImages(
        selectedProduct?.metadata?.images
          ? selectedProduct?.metadata?.images.map((img) =>
              img.name === 'Super Resolution - PALM'
                ? { ...img, name: 'Flow Cytometry' }
                : img
            )
          : []
      )
      setSds(selectedProduct?.metadata?.sds ? selectedProduct?.metadata?.sds : null)
      setCoa(selectedProduct?.metadata?.coa ? selectedProduct?.metadata?.coa : null)
      setProteinApplication(selectedProduct?.metadata?.protein_application ? selectedProduct?.metadata?.protein_application : [])
      setMicroscopyApplication(selectedProduct?.metadata?.microscopy_application ? selectedProduct?.metadata?.microscopy_application : [])
      setUniprotId(selectedProduct?.metadata?.uniprotId ? selectedProduct?.metadata?.uniprotId : '')
      setGeneId(selectedProduct?.metadata?.geneId ? selectedProduct?.metadata?.geneId : '')
      setGeneAliases(selectedProduct?.metadata?.geneAliases ? selectedProduct?.metadata?.geneAliases : '')
      setGeneSymbol(selectedProduct?.metadata?.geneSymbol ? selectedProduct?.metadata?.geneSymbol : '')
      setCloneId(selectedProduct?.metadata?.cloneId ? selectedProduct?.metadata?.cloneId : '')
      setHost(selectedProduct?.host ? selectedProduct?.host : '')
      setClonality(selectedProduct?.clonality ? selectedProduct?.clonality : '')
      setChainSpecificity(selectedProduct?.chain_specification ? selectedProduct?.chain_specification : '')
      setBindingSpecificity(selectedProduct?.binding_specification ? selectedProduct?.binding_specification : [])
      setSpeciesReactivity(selectedProduct?.species_reactivity ? selectedProduct?.species_reactivity : '')
      setDye(selectedProduct?.dyes ? selectedProduct?.dyes : '')
      setEmissionColor(selectedProduct?.emission_color ? selectedProduct?.emission_color : '')
      setEmissionWavelength(selectedProduct?.emission_wavelength ? selectedProduct?.emission_wavelength : '')
      setExcitationWavelength(selectedProduct?.excitation_wavelength ? selectedProduct?.excitation_wavelength : '')
      setExtinctionCoefficient(selectedProduct?.extinction_coefficient ? selectedProduct?.extinction_coefficient : '')
      setMolecularWeight(selectedProduct?.molecular_weight ? selectedProduct?.molecular_weight : '')
      setDillusionalMicroscopy(selectedProduct?.dillusion_microscopy)
      setImmunogen(selectedProduct?.immunogen ? selectedProduct?.immunogen : '')
      setProteinDescription(selectedProduct?.description ? selectedProduct?.description : selectedProduct?.metadata?.description ? selectedProduct?.metadata?.description : '')
      setProductNumber(selectedProduct?.material)
      setIsFeatured(selectedProduct?.featured)
      setThermofisherLink(selectedProduct?.metadata?.thermofisher_link ? selectedProduct?.metadata?.thermofisher_link : '')
      setModifications(selectedProduct?.metadata?.modifications ? selectedProduct?.metadata?.modifications : '')
      if (selectedProduct?.categories[0]?.name === 'PA-MM Mouse Monoclonal') {
        setProductType('PA - Primary Antibody')
        setSubProductType('PA-MM - Mouse Monoclonal')
      } else if (selectedProduct?.categories[0]?.name === 'PA-MR Mouse Recombinant Monoclonal') {
        setProductType('PA - Primary Antibody')
        setSubProductType('PA-MR - Mouse Recombinant Monoclonal')
      } else if (selectedProduct?.categories[0]?.name === 'PA-RR Rabbit Recombinant Monoclonal') {
        setProductType('PA - Primary Antibody')
        setSubProductType('PA-RR - Rabbit Recombinant Monoclonal')
      } else if (selectedProduct?.categories[0]?.name === 'PA-RP Rabbit Polyclonal') {
        setProductType('PA - Primary Antibody')
        setSubProductType('PA-RP - Rabbit Polyclonal')

      } else if (selectedProduct?.categories[0]?.name === 'PA-RTM Rat Monoclonal') {
        setProductType('PA - Primary Antibody')
        setSubProductType('PA-RTM - Rat Monoclonal')
      } else if (selectedProduct?.categories[0]?.name === 'Alexa Flour Primary Antibodies') {
        setProductType('DC - Primary Antibody Direct Conjugate')
        setSubProductType('')
      } else if (selectedProduct?.categories[0]?.name === 'Alexa Flour Secondary Antibodies') {
        setProductType('SA - Secondary Antibody')
        setSubProductType('')
      } else if (selectedProduct?.categories[0]?.name === 'Buffers') {
        setProductType('BU')
        setSubProductType('')
      } else if (selectedProduct?.categories[0]?.name === 'Glass') {
        setProductType('GL')
        setSubProductType('')
      } else if (selectedProduct?.categories[0]?.name === 'Mounting Medium') {
        setProductType('MM')
        setSubProductType('')
      }

    }

  }, [selectedProduct])

  useEffect(() => {
    let data = prefillData(dye)
    if (data) {
      setExcitationWavelength(data.excitation_wavelength)
      setEmissionWavelength(data.emission_wavelength)
      setExtinctionCoefficient(data.extinction_coefficient)
      setMolecularWeight(data.molecular_weight)
      setEmissionColor(data.emission_color)
    } else {
      setExcitationWavelength('')
      setEmissionWavelength('')
      setExtinctionCoefficient('')
      setMolecularWeight('')
      setEmissionColor('')
    }
  }, [dye])

  const isValidURL = (url) => {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[^\s]*)?$/;
    return regex.test(url);
  };
  
  
  const handleReferenceChange = (index, value) => {  
    setReference(prevReference => {
      const newReference = [...prevReference];
      newReference[index] = value;
      return newReference;
    });
  };

  const handleReferenceBlur = (value, fn= () => {}) => {
    if (value && !isValidURL(value)) {
      setNotification({
        message: "Invalid URL",
        type: "red"
      })
      fn('')
    }
  }

// useEffect(() => {
//   let timeoutId;

//   const autoSave = () => {
//     editProduct(payloadData, true);
//   };

//   if (selectedProduct && selectedProductCategory && !isDisabled()) {
//     timeoutId = setInterval(autoSave, 5 * 60 * 1000);
//   }

//   return () => clearInterval(timeoutId);
// }, [selectedProductCategory, payloadData]);

  
  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>{selectedProduct ? 'Edit Product' : 'Add Product'}</span></div>
        <div className="header-search-container">
          <Checkbox
            style={{ fontSize: '16px', fontWeight: 500 }}
            label='Add to featured product'
            checked={isFeatured}
            onChange={(e) => {
              if (e.target.checked) {
                setIsFeatured(true)
              } else {
                setIsFeatured(false)
              }
            }}
          />
          <button className='btn' onClick={() => {
            generatePDF('all', selectedProduct?.id)
          }}>Send to Sharepoint</button>
          <button className='transparent' onClick={() => {
            setOpenAddProduct(false)
            setSelectedProduct(null)
          }} >Cancel</button>
          <button className='btn'
            disabled={isLoading || isDisabled()}
            onClick={() => selectedProduct ? editProduct(payloadData, false) : addProduct(payloadData)}
          >{selectedProduct ? "Save Changes" : "Add Product"}</button>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        <div className="catalog-options">
          <div className="first-container">
            <Input checked={productType === 'PA - Primary Antibody'} radio value="PA - Primary Antibody" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'PA - Primary Antibody' ? 'active-radio radio-containers' : 'radio-containers'} />
            {productType === 'PA - Primary Antibody' &&
              <div className="sub-product">
                <div className="radio-wrapper">
                  <Input checked={subProductType === 'PA-MM - Mouse Monoclonal'} radio value="PA-MM - Mouse Monoclonal" name="subProductType" onChange={(e) => setSubProductType(e.target.value)} className={productType === 'PA-MM - Mouse Monoclonal' ? 'active-radio radio-containers' : 'radio-containers'} />
                  {subProductType === 'PA-MM - Mouse Monoclonal' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
                </div>
                <div className="radio-wrapper">
                  <Input checked={subProductType === 'PA-MR - Mouse Recombinant Monoclonal'} radio value="PA-MR - Mouse Recombinant Monoclonal" name="subProductType" onChange={(e) => setSubProductType(e.target.value)} className={productType === 'PA-MR - Mouse Recombinant Monoclonal' ? 'active-radio radio-containers' : 'radio-containers'} />
                  {subProductType === 'PA-MR - Mouse Recombinant Monoclonal' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
                </div>
                <div className="radio-wrapper">
                  <Input checked={subProductType === 'PA-RR - Rabbit Recombinant Monoclonal'} radio value="PA-RR - Rabbit Recombinant Monoclonal" name="subProductType" onChange={(e) => setSubProductType(e.target.value)} className={productType === 'PA-RR - Rabbit Recombinant Monoclonal' ? 'active-radio radio-containers' : 'radio-containers'} />
                  {subProductType === 'PA-RR - Rabbit Recombinant Monoclonal' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
                </div>
                <div className="radio-wrapper">
                  <Input checked={subProductType === 'PA-RP - Rabbit Polyclonal'} radio value="PA-RP - Rabbit Polyclonal" name="subProductType" onChange={(e) => setSubProductType(e.target.value)} className={productType === 'PA-RP - Rabbit Polyclonal' ? 'active-radio radio-containers' : 'radio-containers'} />
                  {subProductType === 'PA-RP - Rabbit Polyclonal' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
                </div>
                <div className="radio-wrapper">
                  <Input checked={subProductType === 'PA-RTM - Rat Monoclonal'} radio value="PA-RTM - Rat Monoclonal" name="subProductType" onChange={(e) => setSubProductType(e.target.value)} className={productType === 'PA-RTM - Rat Monoclonal' ? 'active-radio radio-containers' : 'radio-containers'} />
                  {subProductType === 'PA-RTM - Rat Monoclonal' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
                </div>
              </div>
            }
            <div className="radio-wrapper">
              <Input checked={productType === 'DC - Primary Antibody Direct Conjugate'} radio value="DC - Primary Antibody Direct Conjugate" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'DC - Primary Antibody Direct Conjugate' ? 'active-radio radio-containers' : 'radio-containers'} />
              {productType === 'DC - Primary Antibody Direct Conjugate' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
            </div>
            <div className="radio-wrapper">
              <Input checked={productType === 'SA - Secondary Antibody'} radio value="SA - Secondary Antibody" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'SA - Secondary Antibody' ? 'active-radio radio-containers' : 'radio-containers'} />
              {productType === 'SA - Secondary Antibody' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled style={{ pointerEvents: 'none', textAlign: 'center', width: '100%' }} />}
            </div>
            <div className="batch-wrapper">
              <h4>Batch Number</h4>
              <p>Enter batch number for selected product</p>
              <div className="batch-input-wrapper">
                <Input type='text' placeholder={'B00001'} value={batchNumber[0]} onChange={(e) => setBatchNumber([e.target.value, batchNumber[1], batchNumber[2], batchNumber[3], batchNumber[4], batchNumber[5]])} />
                <Input type='text' placeholder={'B00001'} value={batchNumber[1]} onChange={(e) => setBatchNumber([batchNumber[0], e.target.value, batchNumber[2], batchNumber[3], batchNumber[4], batchNumber[5]])} />
                <Input type='text' placeholder={'B00001'} value={batchNumber[2]} onChange={(e) => setBatchNumber([batchNumber[0], batchNumber[1], e.target.value, batchNumber[3], batchNumber[4], batchNumber[5]])} />
                <Input type='text' placeholder={'B00001'} value={batchNumber[3]} onChange={(e) => setBatchNumber([batchNumber[0], batchNumber[1], batchNumber[2], e.target.value, batchNumber[4], batchNumber[5]])} />
                <Input type='text' placeholder={'B00001'} value={batchNumber[4]} onChange={(e) => setBatchNumber([batchNumber[0], batchNumber[1], batchNumber[2], batchNumber[3], e.target.value, batchNumber[5]])} />
                <Input type='text' placeholder={'B00001'} value={batchNumber[5]} onChange={(e) => setBatchNumber([batchNumber[0], batchNumber[1], batchNumber[2], batchNumber[3], batchNumber[4], e.target.value])} />
              </div>
            </div>
          </div>
          <div className="second-container">
          {productType !== 'SA - Secondary Antibody' &&  <div className="reference-wrapper">
              <h4 style={{ marginBottom: '10px' }}>Select Protein Name<span style={{ color: '#DC1E00' }}>*</span></h4>
              <Dropdown options={proteinsList} searchable label={'Select Protein Name'} value={proteinName} onChange={(e) => setProteinName(e)} />
            </div>
            }
            {/* <div className="radio-wrapper">
              <Input checked={productType === 'BU'} radio value="BU" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'BU' ? 'active-radio radio-containers' : 'radio-containers'} />
              {productType === 'BU' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled />}
            </div>
            <div className="radio-wrapper">
              <Input checked={productType === 'GL'} radio value="GL" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'GL' ? 'active-radio radio-containers' : 'radio-containers'} />
              {productType === 'GL' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled />}
            </div>
            <div className="radio-wrapper">
              <Input checked={productType === 'MM'} radio value="MM" name="productType" onChange={(e) => setProductType(e.target.value)} className={productType === 'MM' ? 'active-radio radio-containers' : 'radio-containers'} />
              {productType === 'MM' && <Input type='text' placeholder={'000001'} value={`${productNumber}`} disabled />}
            </div> */}
            <div className="reference-wrapper">
                  <h4 style={{ marginBottom: '10px' }}>Clone Number</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Clone Number'} value={cloneId} onChange={(e) => setCloneId(e.target.value)} />
                  </div>
            </div>
            <div className="reference-wrapper">
           {selectedProduct?.id && <button className='btn'
           disabled={isLoading}
           onClick={() => {
            generatePDF('sds', selectedProduct?.id)
            }}>{sds?.url ? 'Regenerate SDS' : 'Generate SDS'}</button>
          }
            {sds?.url && <p className='sds-name'><a href={sds?.url} target="_blank">{sds?.url}</a><i className="fas fa-times" onClick={() => setSds(null)}></i></p>}
          </div>
          <div className="reference-wrapper">
           {selectedProduct?.id && <button className='btn'
           disabled={isLoading}
           onClick={() => {
            generatePDF('coa', selectedProduct?.id)
            }}>{coa?.url ? 'Regenerate COA' : 'Generate COA'}</button>
          }
            {coa?.url && <p className='sds-name'><a href={coa?.url} target="_blank">{coa?.url}</a><i className="fas fa-times" onClick={() => setCoa(null)}></i></p>}
          </div>
          </div>
        </div>
        {productType !== 'SA - Secondary Antibody' &&
          <ProtienInformation>
            <div className="header">
              <h4>Protein Information</h4>
            </div>
            <div className="content">
              <div className="first-container">
                <div className="reference-wrapper">
                  <h4>Protein Name<span style={{ color: '#DC1E00' }}>*</span></h4>
                  <p>Human prefix for Protein name</p>
                  <div className="single-input-wrapper">
                    <Input isDisabled type='text' placeholder={'Select Protein Name from above dropdown'} style={{ paddingLeft: '75px' }} otherText={'Human'} value={proteinName} onChange={(e) => setProteinName(e.target.value)} />
                  </div>
                </div>
                <div className="reference-wrapper">
                  <h4>Protein Description<span style={{ color: '#DC1E00' }}>*</span></h4>
                  <p>Write description, 500 Characters​</p>
                  <div className="single-input-wrapper">
                    <textarea
                      style={{ resize: "none", borderRadius: "8px" }}
                      placeholder='Write Product Description'
                      value={proteinDescription}
                      onChange={(e) => setProteinDescription(e.target.value.slice(0, 500))}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="second-container">
                <div className="reference-wrapper">
                  <h4>Reference</h4>
                  <p>Add reference links</p>
                  <div className="reference-input-wrapper">
                  {new Array(8).fill('').map((item, index) => (
                    <Input type='text' placeholder={'Enter Link'} key={index} value={reference[index]} onChange={(e) => handleReferenceChange(index, e.target.value)} onBlur={(e) => handleReferenceBlur(e.target.value)} isBlur  />
                  ))}
                  </div>
                </div>
              </div>
            </div>
          </ProtienInformation>
        }
        <ProductInformation>
          <div className="header">
            <h4>Product Information</h4>
          </div>
          <div className="content" style={{ gridTemplateColumns: productType === 'SA - Secondary Antibody' ? '50% 50%' : '50% 50%' }}>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Product Name<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Product name appears according selection</p>
                <div className="single-input-wrapper">
                  <div className='disabled-field' dangerouslySetInnerHTML={{ __html: tempProductName }}></div>
                  {/* <Input type='text' placeholder={'Enter Name'} value={'Mouse Monoclonal Anti-Human PARP1'} isDisabled /> */}
                </div>
              </div>
              {productType !== "SA - Secondary Antibody" &&
              <>
                <div className="reference-wrapper">
                  <h4>Immunogen <span style={{ color: '#DC1E00' }}>*</span></h4>
                  <p>Variant of the protein (displays on <span style={{ fontWeight: '600' }}>coA only</span>)​</p>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Type Here'} value={immunogen} onChange={(e) => setImmunogen(e.target.value)} />
                  </div>
                </div>
                <div className="two-column">
                <div className="reference-wrapper">
                  <h4>Uniprot ID</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Uniprot ID'} value={uniprotId} onChange={(e) => setUniprotId(e.target.value)} />
                  </div>
            </div>
            <div className="reference-wrapper">
                  <h4>Gene ID</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Gene ID'} value={geneId} onChange={(e) => setGeneId(e.target.value)} />
                  </div>
            </div>
                 </div>
                <div className="two-column">
                <div className="reference-wrapper">
                  <h4>Gene Symbol</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Gene Symbol'} value={geneSymbol} onChange={(e) => setGeneSymbol(e.target.value)} />
                  </div>
                  </div>
                  <div className="reference-wrapper">
                  <h4>Gene Aliases</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Gene Aliases'} value={geneAliases} onChange={(e) => setGeneAliases(e.target.value)} />
                  </div>
                  </div>
                 </div>
                </>
              }
            </div>
            {productType !== 'SA - Secondary Antibody' &&
              <div className="second-container" style={{ marginTop: '33px' }}>
                <div className="reference-wrapper">
                  <p>Select any either Mouse, Rabbit or Rat</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${host === 'Mouse' ? 'active-btn' : ''}`} onClick={(e) => setHost('Mouse')} disabled={clonality === 'Polyclonal'}>Mouse</button>
                    <button className={`btn ${host === 'Rabbit' ? 'active-btn' : ''}`} onClick={(e) => setHost('Rabbit')} disabled={clonality === 'Monoclonal'}>Rabbit</button>
                    <button className={`btn ${host === 'Rat' ? 'active-btn' : ''}`} onClick={(e) => setHost('Rat')} disabled={clonality === 'Recombinant Monoclonal' || clonality === 'Polyclonal'}>Rat</button>
                  </div>
                </div>
                <div className="reference-wrapper">
                  <p>Select one clonality</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${clonality === 'Monoclonal' ? 'active-btn' : ''}`} onClick={(e) => setClonality('Monoclonal')} disabled={host === 'Rabbit'}>Monoclonal</button>
                    <button className={`btn ${clonality === 'Polyclonal' ? 'active-btn' : ''}`} onClick={(e) => setClonality('Polyclonal')} disabled={host === 'Mouse' || host === 'Rat'}>Polyclonal</button>
                    <button className={`btn ${clonality === 'Recombinant Monoclonal' ? 'active-btn' : ''}`} onClick={(e) => setClonality('Recombinant Monoclonal')} disabled={host === 'Rat'}>Recombinant Monoclonal</button>
                  </div>
                </div>
                <div className="reference-wrapper">
                  <p>Select any one of these options (<span style={{ fontWeight: 600 }}>optional</span>)</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${variant === 'Human Fc' ? 'active-btn' : ''}`} onClick={(e) => {
                      if (variant === 'Human Fc') {
                        setVariant('')
                      } else {
                        setVariant('Human Fc')
                      }
                    }}>Human Fc</button>
                    <button className={`btn ${variant === 'Mouse Fc' ? 'active-btn' : ''}`} onClick={(e) => {
                      if (variant === 'Mouse Fc') {
                        setVariant('')
                      } else {
                        setVariant('Mouse Fc')
                      }
                    }}>Mouse Fc</button>
                  </div>
                </div>
                <div className="reference-wrapper">
                  <p>Select any one of these subclass options (displays on <span style={{ fontWeight: 600 }}>coA only</span>)</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${subclass === 'IgG' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG')}>IgG</button>
                    <button className={`btn ${subclass === 'IgG1' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG1')}>IgG1</button>
                    <button className={`btn ${subclass === 'IgG2a' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG2a')}>IgG2a</button>
                    <button className={`btn ${subclass === 'IgG2b' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG2b')}>IgG2b</button>
                    <button className={`btn ${subclass === 'IgG2c' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG2c')}>IgG2c</button>
                    <button className={`btn ${subclass === 'IgG3' ? 'active-btn' : ''}`} onClick={(e) => setSubclass('IgG3')}>IgG3</button>
                  </div>
                </div>
                <div className="reference-wrapper">
                  <h4 style={{ marginBottom: '10px' }}>Modifications</h4>
                  <div className="single-input-wrapper">
                    <Input type='text' placeholder={'Enter Modifications'} value={modifications} onChange={(e) => setModifications(e.target.value)} />
                  </div>
                </div>
              </div>
            }
            {/* {productType === 'SA - Secondary Antibody' &&
              <div className="second-container">
              
              </div>
            } */}
            {productType === 'SA - Secondary Antibody' &&
              <div className="second-container">
                <div className="reference-wrapper" style={{ padding: '35px 0 0 0' }}>
                  <p>Host</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${host === 'Goat' ? 'active-btn' : ''}`} onClick={(e) => setHost('Goat')}>Goat</button>
                    <button className={`btn ${host === 'Donkey' ? 'active-btn' : ''}`} onClick={(e) => setHost('Donkey')}>Donkey</button>
                    <button className={`btn ${host === 'Rabbit' ? 'active-btn' : ''}`} onClick={(e) => setHost('Rabbit')}>Rabbit</button>
                  </div>
                </div>
                <div className="reference-wrapper" style={{ marginTop: '16px' }}>
                  <p>Species Reactivity</p>
                  <div className="multiple-input-wrapper">
                    <button className={`btn ${speciesReactivity === 'Anti-Mouse' ? 'active-btn' : ''}`} onClick={(e) => setSpeciesReactivity('Anti-Mouse')}>Anti-Mouse</button>
                    <button className={`btn ${speciesReactivity === 'Anti-Rabbit' ? 'active-btn' : ''}`} onClick={(e) => setSpeciesReactivity('Anti-Rabbit')}>Anti-Rabbit</button>
                    <button className={`btn ${speciesReactivity === 'Anti-Human' ? 'active-btn' : ''}`} onClick={(e) => setSpeciesReactivity('Anti-Human')} >Anti-Human</button>
                    <button className={`btn ${speciesReactivity === 'Anti-Rat' ? 'active-btn' : ''}`} onClick={(e) => setSpeciesReactivity('Anti-Rat')}>Anti-Rat</button>
                  </div>
                </div>
              </div>
            }
          </div>
          {productType !== 'PA - Primary Antibody' && <div className="reference-wrapper" style={{ padding: '0 44px' }}>
            <h4>Dyes </h4>
            <p>Select One Dye</p>
            <div className="multiple-input-wrapper">
              <button className={`btn ${dye === '405' ? 'active-btn' : 'blue'}`} onClick={(e) => setDye('405')}>Alexa 405</button>
              <button className={`btn ${dye === '430' ? 'active-btn' : 'blue'}`} onClick={(e) => setDye('430')}>Alexa 430</button>
              <button className={`btn ${dye === '488' ? 'active-btn' : 'green'}`} onClick={(e) => setDye('488')}>Alexa 488</button>
              <button className={`btn ${dye === '532' ? 'active-btn' : 'yellow'}`} onClick={(e) => setDye('532')}>Alexa 532</button>
              <button className={`btn ${dye === '546' ? 'active-btn' : 'yellow'}`} onClick={(e) => setDye('546')}>Alexa 546</button>
              <button className={`btn ${dye === '555' ? 'active-btn' : 'orange'}`} onClick={(e) => setDye('555')}>Alexa 555</button>
              <button className={`btn ${dye === '568' ? 'active-btn' : 'orange'}`} onClick={(e) => setDye('568')}>Alexa 568</button>
              <button className={`btn ${dye === '594' ? 'active-btn' : 'pink'}`} onClick={(e) => setDye('594')}>Alexa 594</button>
              <button className={`btn ${dye === '610' ? 'active-btn' : 'pink'}`} onClick={(e) => setDye('610')}>Alexa 610</button>
              <button className={`btn ${dye === '633' ? 'active-btn' : 'pink'}`} onClick={(e) => setDye('633')}>Alexa 633</button>
              <button className={`btn ${dye === '635' ? 'active-btn' : 'pink'}`} onClick={(e) => setDye('635')}>Alexa 635</button>
              <button className={`btn ${dye === '647' ? 'active-btn' : 'dark-pink'}`} onClick={(e) => setDye('647')}>Alexa 647</button>
              <button className={`btn ${dye === '660' ? 'active-btn' : 'dark-pink'}`} onClick={(e) => setDye('660')}>Alexa 660</button>
              <button className={`btn ${dye === '680' ? 'active-btn' : 'brown'}`} onClick={(e) => setDye('680')}>Alexa 680</button>
              <button className={`btn ${dye === '700' ? 'active-btn' : 'brown'}`} onClick={(e) => setDye('700')}>Alexa 700</button>
              <button className={`btn ${dye === '750' ? 'active-btn' : 'dark-brown'}`} onClick={(e) => setDye('750')}>Alexa 750</button>
              <button className={`btn ${dye === '790' ? 'active-btn' : 'dark-brown'}`} onClick={(e) => setDye('790')}>Alexa 790</button>
            </div>
          </div>
          }
          {productType === 'SA - Secondary Antibody' &&
            <div className="reference-wrapper" style={{ padding: '35px 44px', display: 'flex', justifyContent: 'space-between' }}>
              <div className="first-container">
                <h4>Select Antibody Fragment Length</h4>
                <p>Select one</p>
                <div className="multiple-input-wrapper">
                  <button className={`btn ${chainSpecificity === "F(ab’)₂" ? 'active-btn' : ''}`}
                    onClick={() => {
                      setChainSpecificity("F(ab’)₂")
                    }}>F(ab’)₂</button>
                  <button className={`btn ${chainSpecificity === 'IgG' ? 'active-btn' : ''}`}
                    onClick={() => {
                      setChainSpecificity('IgG')
                    }}>Whole IgG</button>
                </div>
              </div>
              <div className="first-container">
                <h4>Select Antibody and Binding Specificity​</h4>
                <p>Select one or both</p>
                <div className="multiple-input-wrapper">
                  <button className={`btn ${bindingSpecificity.includes('(H + L)') ? 'active-btn' : ''}`}
                    onClick={() => {
                      if (!bindingSpecificity.includes('(H + L)')) {
                        setBindingSpecificity([...bindingSpecificity, '(H + L)'])
                      } else {
                        setBindingSpecificity(bindingSpecificity.filter(item => item !== '(H + L)'))
                      }
                    }}>(H + L)</button>
                  <button className={`btn ${bindingSpecificity.includes("(Subclasses 1+2a+2b+3)") ? 'active-btn' : ''}`}
                    onClick={() => {
                      if (!bindingSpecificity.includes("(Subclasses 1+2a+2b+3)")) {
                        setBindingSpecificity([...bindingSpecificity, "(Subclasses 1+2a+2b+3)"])
                      } else {
                        setBindingSpecificity(bindingSpecificity.filter(item => item !== "(Subclasses 1+2a+2b+3)"))
                      }
                    }} >(Subclasses 1+2a+2b+3), Fcy Fragment Specific</button>
                </div>
              </div>
            </div>
          }
          <div className="reference-wrapper" style={{ padding: '0 44px' }}>
          <h4 style={{ marginBottom: '10px' }}>Thermofisher Product Link</h4>
          <Input type='text' placeholder={'Enter Thermofisher Product Link'} value={thermofisherLink} onChange={(e) => {
            setThermofisherLink(e.target.value)
          }} onBlur={(e) => handleReferenceBlur(e.target.value, setThermofisherLink)} isBlur  />
          </div>
        </ProductInformation>
        {/* dye characterstics */}
        {productType !== 'PA - Primary Antibody' && <DyeInformation>
          <div className="header">
            <h4>Dye Characteristics</h4>
          </div>
          <div className="content" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Excitation Wavelength​​<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Excitation Wavelength</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={excitationWavelength} onChange={(e) => {
                    let value = e.target.value
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    value = value.replace(/[^\d.]+/g, '');
                    setExcitationWavelength(value)
                  }} suffix={'nm'} />
                </div>
              </div>
              <div className="reference-wrapper">
                <h4>Molecular Weight​​<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Molecular Weight</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={molecularWeight} onChange={(e) => {
                    let value = e.target.value
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    value = value.replace(/[^\d.]+/g, '');
                    setMolecularWeight(value)
                  }} suffix={'Da'} />
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Emission Wavelength<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Emission Wavelength</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={emissionWavelength} onChange={(e) => {
                    let value = e.target.value
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    value = value.replace(/[^\d.]+/g, '');
                    setEmissionWavelength(value)
                  }} suffix={'nm'} />
                </div>
              </div>
              <div className="reference-wrapper">
                <h4>Emission Color<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Emission Color</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={emissionColor} onChange={(e) => setEmissionColor(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Extinction Coefficient<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Extinction Coefficient</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={extinctionCoefficient}
                    onChange={(e) => {
                      let value = e.target.value
                      if ((value.match(/\./g) || []).length > 1) {
                        value = value.slice(0, -1);
                      }
                      value = value.replace(/[^\d.]+/g, '');
                      setExtinctionCoefficient(value)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </DyeInformation>
        }
        {/* product formulation */}
        <ProductFormulation>
          <div className="header">
            <h4>Product Formulation</h4>
          </div>
          <div className="content">
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Buffer<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select any one buffer</p>
                <div className="single-input-wrapper">
                  <button className={`btn ${buffer === 'Phosphate Buffer' ? 'active-btn' : ''}`} onClick={(e) => setBuffer('Phosphate Buffer')}>Phosphate Buffer</button>
                  <button className={`btn ${buffer === 'Borate Buffer' ? 'active-btn' : ''}`} onClick={(e) => setBuffer('Borate Buffer')}>Borate Buffer</button>
                  <button className={`btn ${buffer === 'Tris Buffer' ? 'active-btn' : ''}`} onClick={(e) => setBuffer('Tris Buffer')}>Tris Buffer</button>
                  <button className={`btn ${buffer === 'Citrate Buffer' ? 'active-btn' : ''}`} onClick={(e) => setBuffer('Citrate Buffer')}>Citrate Buffer</button>
                  <button className={`btn ${buffer === 'Acetate Buffer' ? 'active-btn' : ''}`} onClick={(e) => setBuffer('Acetate Buffer')}>Acetate Buffer</button>
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Buffer Molarity(mM)<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select any one buffer molarity</p>
                <div className="reference-input-wrapper">
                  <button className={`btn ${bufferMolarity === '10' ? 'active-btn' : ''}`} onClick={(e) => setBufferMolarity('10')}>10</button>
                  <button className={`btn ${bufferMolarity === '20' ? 'active-btn' : ''}`} onClick={(e) => setBufferMolarity('20')}>20</button>
                  <button className={`btn ${bufferMolarity === '50' ? 'active-btn' : ''}`} onClick={(e) => setBufferMolarity('50')}>50</button>
                  <button className={`btn ${bufferMolarity === '100' ? 'active-btn' : ''}`} onClick={(e) => setBufferMolarity('100')}>100</button>
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>pH<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select any one pH</p>
                <div className="reference-input-wrapper">
                  <button className={`btn ${ph === '5.5' ? 'active-btn' : ''}`} onClick={(e) => setPh('5.5')}>5.5</button>
                  <button className={`btn ${ph === '5.8' ? 'active-btn' : ''}`} onClick={(e) => setPh('5.8')}>5.8</button>
                  <button className={`btn ${ph === '6.0' ? 'active-btn' : ''}`} onClick={(e) => setPh('6.0')}>6.0</button>
                  <button className={`btn ${ph === '6.2' ? 'active-btn' : ''}`} onClick={(e) => setPh('6.2')}>6.2</button>
                  <button className={`btn ${ph === '6.4' ? 'active-btn' : ''}`} onClick={(e) => setPh('6.4')}>6.4</button>
                  <button className={`btn ${ph === '6.6' ? 'active-btn' : ''}`} onClick={(e) => setPh('6.6')}>6.6</button>
                  <button className={`btn ${ph === '6.8' ? 'active-btn' : ''}`} onClick={(e) => setPh('6.8')}>6.8</button>
                  <button className={`btn ${ph === '7.0' ? 'active-btn' : ''}`} onClick={(e) => setPh('7.0')}>7.0</button>
                  <button className={`btn ${ph === '7.2' ? 'active-btn' : ''}`} onClick={(e) => setPh('7.2')}>7.2</button>
                  <button className={`btn ${ph === '7.4' ? 'active-btn' : ''}`} onClick={(e) => setPh('7.4')}>7.4</button>
                  <button className={`btn ${ph === '8.0' ? 'active-btn' : ''}`} onClick={(e) => setPh('8.0')}>8.0</button>
                  <button className={`btn ${ph === '8.2' ? 'active-btn' : ''}`} onClick={(e) => setPh('8.2')}>8.2</button>
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Preservative<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select any one Preservative</p>
                <div className="single-input-wrapper">
                  <button className={`btn ${preservative === 'Proclin 300' ? 'active-btn' : ''}`} onClick={(e) => setPreservative('Proclin 300')}>Proclin 300</button>
                  <button className={`btn ${preservative === 'SDS' ? 'active-btn' : ''}`} onClick={(e) => setPreservative('SDS')}>SDS</button>
                  <button className={`btn ${preservative === 'Azide' ? 'active-btn' : ''}`} onClick={(e) => setPreservative('Azide')}>Azide</button>
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Cyropreservative<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select any one Cyropreservative</p>
                <div className="single-input-wrapper">
                  <button className={`btn ${cyroPreservative === 'Glycerol' ? 'active-btn' : ''}`} onClick={(e) => setCyroPreservative('Glycerol')}>Glycerol</button>
                  <button className={`btn ${cyroPreservative === 'PEG' ? 'active-btn' : ''}`} onClick={(e) => setCyroPreservative('PEG')}>PEG</button>
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Storage<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select multiple storage</p>
                <div className="single-input-wrapper">
                  {productType === 'PA - Primary Antibody' && <button className={`btn ${storage.includes('-80') ? 'active-btn' : ''}`}
                    onClick={() => {
                      if (!storage.includes('-80')) {
                        setStorage([...storage, '-80'])
                      } else {
                        setStorage(storage.filter(item => item !== '-80'))
                      }
                    }}
                  >-80°C</button>
                  }
                  {productType === 'PA - Primary Antibody' && <button className={`btn ${storage.includes('-20') ? 'active-btn' : ''}`}
                    onClick={() => {
                      if (!storage.includes('-20')) {
                        setStorage([...storage, '-20'])
                      } else {
                        setStorage(storage.filter(item => item !== '-20'))
                      }
                    }}
                  >-20°C</button>
                  }
                  <button className={`btn ${storage.includes('4') ? 'active-btn' : ''}`}
                    onClick={() => {
                      if (!storage.includes('4')) {
                        setStorage([...storage, '4'])
                      } else {
                        setStorage(storage.filter(item => item !== '4'))
                      }
                    }}
                  >4°C</button>
                </div>
              </div>
            </div>
          </div>
          <div className="content" style={{ gridTemplateColumns: '1fr 1fr 1fr', marginTop: '30px' }}>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Concentration(mg/mL)​​<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Concentration</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={concentration} 
                    onChange={(e) => {
                      let value = e.target.value;
                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;

                      setConcentration(value);
                    }}
                    isBlur={true}
                    onBlur={() => {
                      if (!concentration) {
                        setConcentration("");
                        return;
                      }

                      const num = Number(concentration);
                      if (!isNaN(num)) {
                        setConcentration(num.toFixed(2));
                      }
                    }}
                    suffix={'mg/ml'}
                  />
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Effective Dilution Microscopy<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Dilution Microscopy</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={dillusionalMicroscopy} onChange={(e) => setDillusionalMicroscopy(e.target.value.replace(/[^0-9:&-]+/g, ''))} />
                </div>
              </div>
            </div>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Western Blotting<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Enter Western Blotting</p>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Type Here' value={westernBloating} onChange={(e) => setWesternBloating(e.target.value.replace(/[^0-9:&-]+/g, ''))} />
                </div>
              </div>
            </div>
          </div>
        </ProductFormulation>
        {/* other */}
        <ProductInformation>
          <div className="header">
            <h4>Other</h4>
          </div>
          <div className="content">
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Protein Application<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select those that you have data for</p>
                <div className="multiple-input-wrapper">
                  {
                  proteinApplicationsList.map((item, index) => {
                    return (
                    <button 
                      key={index}
                      className={`btn ${proteinApplication.find(_i => _i.abbr === item.abbr) ? 'active-btn' : ''}`}
                      onClick={() => {
                      if (!proteinApplication.find(_i => _i.abbr === item.abbr)) {
                        setProteinApplication([...proteinApplication, item])
                      } else {
                        setProteinApplication(proteinApplication.filter(_i => _i.abbr !== item.abbr))
                      }
                    }}
                    >{item.name}</button>
                    )
                  })            
                  }
                </div>
              </div>
            </div>
            <div className="second-container">
              <div className="reference-wrapper">
                <h4>Microscopy Application<span style={{ color: '#DC1E00' }}>*</span></h4>
                <p>Select those that you have data for</p>
                <div className="multiple-input-wrapper">
                {
                  microscopyApplicationList.map((item, index) => {
                    return (
                    <button 
                      key={index}
                      className={`btn ${microscopyApplication.find(_i => _i.abbr === item.abbr) ? 'active-btn' : ''}`}
                      onClick={() => {
                      if (!microscopyApplication.find(_i => _i.abbr === item.abbr)) {
                        setMicroscopyApplication([...microscopyApplication, item])
                      } else {
                        setMicroscopyApplication(microscopyApplication.filter(_i => _i.abbr !== item.abbr))
                      }
                    }}
                    >{item.name}</button>
                    )
                  })            
                  }
                </div>
              </div>
            </div>
          </div>
        </ProductInformation>
{/* Reference Information */}
  {productType === 'SA - Secondary Antibody' &&      
          <ProtienInformation>
          <div className="header">
            <h4>Reference Information</h4>
          </div>
          <div className="content" style={{ display: 'block' }}>
            <div className="first-container">
              <div className="reference-wrapper">
                <h4>Reference<span style={{ color: '#DC1E00' }}></span></h4>
                <p>Add reference links</p>
                <div className="reference-input-wrapper">
                  {new Array(8).fill('').map((item, index) => (
                    <Input type='text' placeholder={'Enter Link'} key={index} value={reference[index]} onChange={(e) => handleReferenceChange(index, e.target.value)} onBlur={(e) => handleReferenceBlur(e.target.value)} isBlur  />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </ProtienInformation>
}
        {/* images */}
        <ImageInformation>
          <div className="header">
            <h4>Upload Images and Methods</h4>
          </div>
          <div className="content">
          {
          ImagesKey.map((image, index) => {
            return <div className="image-card">
            {isFeatured && 
               <div className="featured-image-container">
               <Checkbox
                 style={{ fontSize: '15px', fontWeight: 500 }}
                 label='Make this featured image'
                 checked={images.find((item) => item?.name == image)?.featuredImage}
                 onChange={(e) => {
                   if (e.target.checked) {
                     setImages(images.map((item) => ({
                       ...item,
                       featuredImage: item.name === image ? true : false
                     })));
                   } else {
                     setImages(images.map((item) => ({
                       ...item,
                       featuredImage: false
                     })));
                   }
                 }}
               />
               </div>
               }
               <h4>{image}</h4>
               <div className="img-container">
                 <input type="file" className='image-file' accept="image/*, video/*" onChange={(e) => uploadImage(e, image)} size={100} />
                 {images.find((item) => item?.name == image)?.url && !videoConversionStatus[image]?.status && <span className='remove-image'
                   onClick={() => {
                     setImages(images.map((item) => {
                       if (item.name === image) {
                         return {
                           ...item,
                           url: ''
                         }
                       }
                       return item
                     }))
                   }}
                 ><i className='fal fa-trash-alt' style={{ fontSize: '14px', color: '#fcfcfc' }} />Remove</span>
                 }
                 {images.find((item) => item?.name == image)?.url ?
                   isVideoFile(images.find((item) => item?.name == image)) ?
                     videoConversionStatus[image]?.status ?
                       <>
                         <i className="fa fa-hourglass-half" alt="" width={24} height={24} />
                         <p>Processing Video...</p>
                       </>
                       : <video src={getMp4Url(images.find((item) => item?.name == image)?.url)} width='100%' height='100%' style={{ objectFit: "cover", borderRadius: "12px", border: '1px dashed #000' }} controls muted loop autoPlay />
                     : <img src={images.find((item) => item?.name == image)?.url} alt="" width='100%' height='100%' style={{ objectFit: "cover", borderRadius: "12px", border: '1px dashed #000' }} />
                   :
                   <>
                     <img src={toAbsoluteUrl('/media/upload.png')} alt="" width={24} height={24} />
                     <p>{image}</p>
                   </>
                 }
               </div>
               <div className="method-header">
                 <p>Enter Method</p>
                 {/* <p>500 characters limit</p> */}
               </div>
               <div className="single-input-wrapper">
                 <TextEditor
                  image={image}
                  editorFocussed={editorFocussed}
                  setEditorFocussed={setEditorFocussed}
                  images={images}
                  setImages={setImages}
                  key={index}
                 />
               </div>
             {selectedProduct?.id && selectedProduct?.metadata?.images.find((item) => item.name === image)?.methods &&
             <div className='pdf-container'>
             <button className='btn pdf-btn'
             disabled={isLoading}
             onClick={() => {
             generatePDF(image, selectedProduct?.id)
             }}>{selectedProduct?.metadata?.images.find((item) => item.name === image)?.pdf ? 'Regenerate PDF' : 'Generate PDF'}</button>
            {selectedProduct?.metadata?.images.find((item) => item.name === image)?.pdf && <span className='btn view-pdf'><a href={selectedProduct?.metadata?.images.find((item) => item.name === image)?.pdf} target="_blank"><i class="fal fa-eye"></i>View PDF</a></span>}
             </div>
             }
             </div>
          })      
          }
          </div>
        </ImageInformation>
        {/* price */}
        <PriceInformation>
          <div className="header">
            <h4>Price</h4>
          </div>
          <div className="content">
              <div className="reference-wrapper" style={{ width: 'max-content' }}>
                <h4>Enter Quantity<span style={{ color: '#DC1E00' }}>*</span></h4>
                <div className="single-input-wrapper">
                  <Input type="text" placeholder='Enter Total Quantity' value={quantity} onChange={(e) => {
                    let value = e.target.value
                    value = value.replace(/[^\d]+/g, '');
                    setQuantity(+value)
                  }}/>
                </div>
              </div>
            </div>
          <div className="content">
            <div className="reference-wrapper" style={{ width: '100%' }}>
              <div className="multiple-input-wrapper">
                {Prices.map((value, index) => <button className={`btn ${price === value ? 'active-btn' : ''}`} key={index}
                  onClick={() => setPrice(value)}
                >{value}</button>)}
              </div>
            </div>
          </div>
        </PriceInformation>
      </ContentWrapper>
    </Layout>
  )
}

export default Index